import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

class DefinicionEstados extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    /**
     * 
     * @param {any} event
     */
    changeComboEstado(event) {
        let estado = this.props.data.deliveryestado.find(x => x.Id == event.target.value);
        let nroEstado = event.target.id.replace('selectEstado', '');
        if (estado !== undefined)
            this.props.asignarNombreEstado(estado, parseInt(nroEstado));
    }

    /**
     * 
     * @param {any} nroEstado
     */
    btnsiguiente(nroEstado) {
        let puedeSeguir = true;
        for (var i = 0; i < this.props.data.estados.length; i++) {
            if (this.props.data.estados[i].EstadoInfo === undefined)
                puedeSeguir = false;
        }

        if (puedeSeguir)
            this.props.siguenteEstado('SIGUIENTE');
    }

    /**
     * 
     */
    btnCancelar() {
        this.props.cancelarEdicion();
    }

    render() {
        //Se cargan la informacion que poblara los combos...
        let estados = null;
        let estadosSeleccionados = []

        for (var i = 0; i < this.props.data.estados.length; i++) {
            if (this.props.data.estados[i].EstadoInfo !== undefined)
                estadosSeleccionados.push(this.props.data.estados[i].EstadoInfo);
        }

        estados = this.props.data.deliveryestado.map((estado) => {
            return (
                <GenericOption key={estado.Id} id={estado.Id} description={estado.Descripcion} />
            )
        })

        let restoCombo = [];
        for (var i = 2; i < parseInt(this.props.data.cantidadEstados) + 1; i++) {
            restoCombo.push(<div className="div-definir-circuito-estados "><label className="label-primary label-definicion-circuito-estados">{i}- ESTADO</label><GenericSelect id={'selectEstado' + i} className="form-control default-select combo-definicion-circuito-estados" options={estados} value={this.props.data.estados[i - 1].EstadoInfo == undefined ? 0 : this.props.data.estados[i - 1].EstadoInfo.Id} onChange={(e, nro) => this.changeComboEstado(e)} /></div>);
        }

        return (
            <div>
                <div className="div-definir-circuito-estados-combos">
                    <label className="label-primary">Cantidad de estados del proceso</label>
                    <br />
                    <div>
                        <label className="label-primary label-definicion-circuito-estados">1- ESTADO</label>
                        <GenericSelect id="selectEstado1" className="form-control default-select combo-definicion-circuito-estados" options={estados}
                            value={this.props.data.estados[0].EstadoInfo == undefined ? 0 : this.props.data.estados[0].EstadoInfo.Id} onChange={(e, nro) => this.changeComboEstado(e)} />
                    </div>
                    <br />

                    <label className="label-primary">Asigne a cada registro un estado que estara incluido en el workflow.
                    Los numeros no tienen directa relación con el orden que luego se le asignara a cada estado en los pasos del proceso.</label>
                    <br />
                    {restoCombo.length == 0 ? null : restoCombo}
                </div>
                
                <div className="div-definir-circuito-estados-boton">
                    <button id="btnComenzar" type="button" className="btn btn-secondary button-estados-anterior" onClick={() => this.btnCancelar()}>
                        Cancelar
                    </button>

                    <button id="btnComenzar" type="button" className="btn btn-cta bto-finalizar-solicitud" onClick={() => this.btnsiguiente()}>
                        Siguiente
                </button>
                </div>
            </div>
        );
    }
}

export default DefinicionEstados;
